import { VortexIPCConnection } from "./utils/VortexIPCConnection";
import { createConnectionStrategies } from "./utils/connectionStrategy";
import { log } from "../../util/log";
/**
 * Test if files are supported by the FOMOD installer
 */
export const testSupported = async (api, files, gameId, details) => {
    if (!["oblivion", "fallout3", "falloutnv"].includes(gameId)) {
        return {
            supported: false,
            requiredFiles: [],
        };
    }
    if (details && details.hasCSScripts === false) {
        return {
            supported: false,
            requiredFiles: [],
        };
    }
    let connection = null;
    try {
        const strategies = createConnectionStrategies();
        connection = new VortexIPCConnection(api, strategies, 10000);
        await connection.initialize();
        const result = await connection.testSupported(files, ["CSharpScript"]);
        log("debug", "FOMOD testSupported result", {
            supported: result.supported,
            requiredFiles: result.requiredFiles,
            gameId,
        });
        return result;
    }
    catch (err) {
        const errorName = err.name || "Error";
        log("error", "FOMOD testSupported failed", {
            errorName,
            error: err.message,
            gameId,
        });
        return {
            supported: false,
            requiredFiles: [],
        };
    }
    finally {
        if (connection) {
            await connection.dispose();
        }
    }
};
